import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { useStores } from '@/store'
import { getQuery } from '../../service/http'
import Button from '../dc-button'
import { Modal } from 'antd'
import './index.less'
import { use } from 'react'

let beforeParams = {}
let tagParams = null

const CollectionFilter = ({ onApply, toggleMap, mapVisible, keyword, setSort, curSort, isClearFilter, setIsClearFilter, isRestaurant }) => {
  const { t } = useTranslation()
  const { restaurantStore } = useStores()
  const { region, lang = 'en' } = getQuery()
  const [modalVisible, setModalVisible] = useState(false)
  const [curFilterKey, setFilterKey] = useState('')
  const [params, setParams] = useState({})
  const [filterParams, setFilterParams] = useState(params)
  const [canApply, setCanApply] = useState(false)
  const [canClear, setCanClear] = useState(false)
  const [selectedParams, setSelectedParams] = useState({})
  const [selectedOrder, setSelectedOrder] = useState([])
  const [moreSelectedVisible, setMoreSelectedVisible] = useState(false)
  const [moreSelectedActive, setMoreSelectedActive] = useState(false)
  const [lastFilterCount, setLastFilterCount] = useState(0)
  const [currentCate, setCurrentCate] = useState('All')
  const [isShowBack, setIsShowBack] = useState(true)
  const [initParamsData, setInitParamsData] = useState({})
  const [filterTypes, setFilterTypes] = useState({
    date: false,
    seats: false,
    location: false,
    cuisines: false,
    filters: false,
    sort: true
  })
  const selectedRef = useRef(null)
  const selectedBoxRef = useRef(null)
  useEffect(() => {
    if (region) {
      restaurantStore
        .getItemParams({
          lang: lang,
          region_id: region
        })
        .then(data => {
          data.cuisines = data.cuisines_categories.map(_ => _.cuisines).flat()
          data.sort = data.order_by
          data.cuisines_categories.unshift({
            name: 'All',
            id: -1,
            cuisines: data.cuisines
          })
          data.sort[0].checked = true
          setInitParamsData(JSON.parse(JSON.stringify(data)))
          setParams(data)
          setSelectedParams({
            sort: [data.sort[0]]
          })
        })
    }
  }, [])

  useEffect(() => {
    if (isClearFilter) {
      setSelectedParams({
        sort: [initParamsData.sort[0]]
      })
      setSelectedOrder([])
      setParams(initParamsData)
      setFilterTypes({
        date: false,
        seats: false,
        location: false,
        cuisines: false,
        filters: false,
        sort: true
      })
      onApply({})
      setIsClearFilter(false)
    }
  }, [isClearFilter])

  useEffect(() => {
    if (params.distance && typeof params.distance[0] === 'number') {
      params.distance = params.distance.map(item => ({
        id: item,
        name: item
      }))
      params.price_range = params.price_range.map(item => {
        item.id = item.start_price + '|' + item.end_price
        item.name = item.view_price
        return item
      })
      params.ratings = params.ratings.map(item => ({
        id: item,
        name: item
      }))
    }
    let dateList = []
    for (let i = 0; i <= 42; i++) {
      const date = moment().add(i, 'days').format('YYYY-M-D')
      dateList.push({ id: i, name: date })
    }
    let seatsList = []
    for (let i = 1; i <= 8; i++) {
      seatsList.push({ id: i, name: `${i} ${i > 1 ? t('Browse.seat') : t('Browse.seat_')}` })
    }
    params.date = dateList
    params.seats = seatsList
    beforeParams = JSON.parse(JSON.stringify(params))
    if (tagParams && Object.keys(params).length > 0) {
      const key = Object.keys(tagParams)[0]
      const tag = params[key].find(_ => _.id === tagParams[key][0]?.id)
      if (tag) {
        tag.checked = true
      }
      applyFilter(params)
    }
    setFilterParams(params)
  }, [params, tagParams])

  useEffect(() => {
    setFilterTypes({
      ...filterTypes,
      sort: !!curSort
    })
  }, [curSort])

  useEffect(() => {
    let hasChecked = false
    for (const key in filterParams) {
      if (Object.hasOwnProperty.call(filterParams, key)) {
        const element = filterParams[key]
        if (element.filter(item => item.checked).length) {
          hasChecked = true
          break
        }
      }
    }
    setCanClear(hasChecked)
    let hasChanged = false
    for (const key in filterParams) {
      if (Object.hasOwnProperty.call(filterParams, key)) {
        const before = filterParams[key] || []
        const after = beforeParams[key] || []
        if (
          before
            .filter(item => item.checked)
            .map(item => item.id)
            .join(',') !==
          after
            .filter(item => item.checked)
            .map(item => item.id)
            .join(',')
        ) {
          hasChanged = true
          break
        }
      }
    }
    setCanApply(hasChanged)
  }, [filterParams, modalVisible])

  useEffect(() => {
    setIsShowBack(false)
  }, [filterParams])

  useEffect(() => {
    const selectedDom = selectedRef.current
    const selectedBoxDom = selectedBoxRef.current
    const maxWidth = selectedBoxDom.offsetWidth
    const selectedItems = Array.from(selectedDom.children)
    let curWidth = 100
    for (let i = 0; i < selectedItems.length; i++) {
      curWidth += selectedItems[i].offsetWidth + 8
      if (curWidth > maxWidth) {
        setMoreSelectedVisible(true)
        setLastFilterCount(selectedItems.length - i)
        break
      }
    }
    if (curWidth <= maxWidth) {
      setMoreSelectedVisible(false)
    }
  }, [selectedParams, keyword])

  function showFilterDialog(item) {
    setFilterKey(item)
    setModalVisible(true)
    setIsShowBack(true)
  }

  function hideFilterDialog() {
    setFilterParams(JSON.parse(JSON.stringify(beforeParams)))
    setModalVisible(false)
  }

  const cuisinesList = useMemo(() => {
    if (!params?.cuisines_categories) {
      return []
    }
    const list = params?.cuisines_categories.find(_ => _.name === currentCate)
    return list ? list.cuisines.map(_ => _?.id) : []
  }, [currentCate, params])

  const haseCheckedItem = key => {
    if (key === -1) return false
    const cuisines = filterParams.cuisines_categories.find(_ => _.id === key)?.cuisines
    const checkedIds = cuisines.filter(item => item.checked).map(item => item.id)
    return cuisines.some(itme => checkedIds.includes(itme.id))
  }

  function changeFilterParams(key, index, type = 'checkbox') {
    let params = { ...filterParams }
    if (type === 'radio') {
      params[key].forEach(item => {
        item.checked = false
      })
    }
    if (key === 'cuisines') {
      index = params[key].findIndex(_ => _.id === index)
    }
    params[key][index].checked = !params[key][index].checked
    setFilterParams(params)
    if (key === 'sort') {
      applyFilter(params, true)
    }
    // setIsShowBack(false)
  }

  function applyFilter(params, isQuery = false) {
    if (isShowBack && !isQuery) {
      hideFilterDialog()
      return
    }
    beforeParams = JSON.parse(JSON.stringify(params || filterParams))
    let obj = {}
    let selected = {}
    let typesActive = {
      date: false,
      seats: false,
      location: false,
      cuisines: false,
      filters: false,
      sort: false
    }
    Object.keys(beforeParams).forEach(key => {
      switch (key) {
        case 'date':
          let date = beforeParams[key].filter(item => item.checked)
          if (date.length) {
            selected.date = date
            typesActive.date = true
            obj['date'] = date.map(item => item.name).join(',')
          }
          break
        case 'sort':
          let sort = beforeParams[key].filter(item => item.checked)
          if (sort.length) {
            selected.sort = sort
            typesActive.sort = true
            obj['sort'] = sort.map(item => item.value).join(',')
          }
          break
        case 'seats':
          let seats = beforeParams[key].filter(item => item.checked)
          if (seats.length) {
            selected.seats = seats
            typesActive.seats = true
            obj['seats'] = seats.map(item => item.id).join(',')
          }
          break
        case 'cuisines':
          let cuisines = beforeParams[key].filter(item => item.checked)
          if (cuisines.length) {
            selected.cuisines = cuisines
            typesActive.cuisines = true
            obj['cuisine_ids'] = cuisines.map(item => item.id)
          }
          break
        case 'locations':
          let locations = beforeParams[key].filter(item => item.checked)
          if (locations.length) {
            selected.locations = locations
            typesActive.location = true
            obj['location_ids'] = locations.map(item => item.id)
          }
          break
        case 'landmarks':
          let landmarks = beforeParams[key].filter(item => item.checked)
          if (landmarks.length) {
            selected.landmarks = landmarks
            typesActive.location = true
            obj['landmark_ids'] = landmarks.map(item => item.id)
          }
          break
        case 'tags':
          let tags = beforeParams[key].filter(item => item.checked)
          if (tags.length) {
            selected.tags = tags
            typesActive.filters = true
            obj['tag_ids'] = tags.map(item => item.id)
          }
          break
        case 'extras':
          let extras = beforeParams[key].filter(item => item.checked)
          if (extras.length) {
            selected.extras = extras
            typesActive.filters = true
            obj['extra_ids'] = extras.map(item => item.id)
          }
          break
        case 'distance':
          let distance = beforeParams[key].find(item => item.checked)
          if (distance) {
            typesActive.filters = true
            selected.distance = [distance]
            obj['distance'] = distance.id
          }
          break
        case 'price_range':
          let price = beforeParams[key].find(item => item.checked)
          if (price) {
            typesActive.filters = true
            selected.price_range = [price]
            obj['price_range'] = price.id.replace('|', ',')
          }
          break
        default:
      }
    })
    setFilterTypes(typesActive)
    let newSelectedOrder = [...selectedOrder]

    // 添加新选择项到顺序列表
    Object.keys(beforeParams).forEach(key => {
      const checkedItems = (beforeParams[key] || []).filter(item => item.checked)
      checkedItems.forEach(item => {
        const exists = newSelectedOrder.find(o => o.key === key && o.id === item.id)
        if (!exists) {
          newSelectedOrder.push({ key, id: item.id })
        }
      })
    })

    // 移除已取消选择的项
    newSelectedOrder = newSelectedOrder.filter(o => (beforeParams[o.key] || []).some(item => item.id === o.id && item.checked))

    setSelectedOrder(newSelectedOrder)
    setSelectedParams(selected)
    setModalVisible(false)
    onApply(obj)
  }

  function removeParams(key, removeName) {
    // 更新弹窗筛选
    let beforeFilterParams = JSON.parse(JSON.stringify(filterParams))
    let index = beforeFilterParams[key].findIndex(item => item.name === removeName)
    beforeFilterParams[key][index].checked = false
    setFilterParams(beforeFilterParams)
    applyFilter(beforeFilterParams)
  }

  function clearFilter() {
    if (!canClear) return
    let params = { ...filterParams }
    if (curFilterKey === 'filters') {
      params.tags.forEach(item => {
        item.checked = false
        return item
      })
      params.price_range.forEach(item => {
        item.checked = false
        return item
      })
      params.distance.forEach(item => {
        item.checked = false
        return item
      })
      params.extras.forEach(item => {
        item.checked = false
        return item
      })
    } else if (curFilterKey === 'cuisines') {
      params.cuisines.forEach(item => {
        item.checked = false
        return item
      })
    } else if (curFilterKey === 'location') {
      params.locations.forEach(item => {
        item.checked = false
        return item
      })
      params.landmarks.forEach(item => {
        item.checked = false
        return item
      })
    } else if (curFilterKey === 'date') {
      params.date.forEach(item => {
        item.checked = false
        return item
      })
    } else if (curFilterKey === 'seats') {
      params.seats.forEach(item => {
        item.checked = false
        return item
      })
    }
    setFilterParams(params)
  }

  return (
    <div className='filters'>
      <div className='filter-buttons'>
        {Object.keys(filterTypes)
          .filter(_ => _ !== 'sort')
          .map(key => (
            <span className={`filter-button ${filterTypes[key] ? 'active' : ''}`} key={key} onClick={() => showFilterDialog(key)}>
              {t(`Browse.${key}`)}
            </span>
          ))}
        <span className={`filter-button ${selectedParams['sort'] ? 'active' : ''}`} onClick={() => showFilterDialog('sort')}>
          {selectedParams['sort'] ? selectedParams['sort']?.[0]?.name : t('Browse.sort')}
        </span>
        {/* <span className={`icon ${mapVisible ? 'icon-list' : 'icon-map'}`} onClick={toggleMap}></span> */}
      </div>
      {
        <div className={`selected-box ${moreSelectedVisible && !moreSelectedActive ? 'hide' : ''}`} ref={selectedBoxRef}>
          <div className='selected' ref={selectedRef}>
            {[...selectedOrder].reverse().map(({ key, id }) => {
              if (key === 'sort') return null
              const item = (selectedParams[key] || []).find(i => i.id === id)
              if (!item) return null
              return (
                <div className='selected-item' key={`${key}-${id}`} onClick={() => removeParams(key, item.name)}>
                  <i className='icon icon-close'></i> {key === 'distance' ? item.name + 'm' : item.name}
                </div>
              )
            })}
          </div>
          {moreSelectedVisible && (
            <div className={`show-more ${moreSelectedActive ? 'active' : ''}`} onClick={() => setMoreSelectedActive(!moreSelectedActive)}>
              {/* {moreSelectedActive ? t('Browse.hide') : `${t('Browse.showMore')} · ${lastFilterCount}`} */}
              {`${t('Browse.showMore')} · ${lastFilterCount}`}
              {moreSelectedActive ? <i className='icon top-red'></i> : <i className='icon down-gary'></i>}
            </div>
          )}
        </div>
      }
      {/* <span className="button map-icon">
              
      </span> */}
      <Modal
        className='collection-filter-modal'
        visible={modalVisible}
        onCancel={hideFilterDialog}
        title={null}
        footer={null}
        closable={false}
      >
        <header>
          {t(`Browse.${curFilterKey}`)}
          {curFilterKey !== 'sort' && (
            <div className={`clear ${canClear ? 'active' : ''}`} onClick={() => clearFilter()}>
              {t('Browse.clear')}
            </div>
          )}
        </header>
        <section style={{ overflow: curFilterKey === 'cuisines' ? 'hidden' : 'auto' }}>
          {curFilterKey === 'date' ? (
            <React.Fragment>
              <div className='filter-date-items'>
                {filterParams?.date.map((item, index) => (
                  <label key={item.id} className={item.checked ? 'active' : ''} onClick={() => changeFilterParams('date', index, 'radio')}>
                    <span>{item.name}</span>
                    {item.checked && <i className='icon icon-check-normal-red' />}
                  </label>
                ))}
              </div>
            </React.Fragment>
          ) : null}
          {curFilterKey === 'seats' ? (
            <React.Fragment>
              <div className='filter-date-items'>
                {filterParams?.seats.map((item, index) => (
                  <label key={item.id} className={item.checked ? 'active' : ''} onClick={() => changeFilterParams('seats', index, 'radio')}>
                    <span>{item.name}</span>
                    {item.checked && <i className='icon icon-check-normal-red' />}
                  </label>
                ))}
              </div>
            </React.Fragment>
          ) : null}
          {curFilterKey === 'location' ? (
            <React.Fragment>
              <div className='filter-title'>{t('Browse.district')}</div>
              <div className='filter-items'>
                {filterParams.locations?.map((item, index) => (
                  <label key={item.id} className={item.checked ? 'active' : ''} onClick={() => changeFilterParams('locations', index)}>
                    <span>{item.name}</span>
                  </label>
                ))}
              </div>
              <div className='filter-title'>{t('Browse.landmarks')}</div>
              <div className='filter-items'>
                {filterParams.landmarks?.map((item, index) => (
                  <label key={item.id} className={item.checked ? 'active' : ''} onClick={() => changeFilterParams('landmarks', index)}>
                    <span>{item.name}</span>
                  </label>
                ))}
              </div>
            </React.Fragment>
          ) : null}
          {curFilterKey === 'cuisines' ? (
            <React.Fragment>
              <div className='cuisines-container'>
                {/* {filterParams.cuisines?.map((item, index) => (
                  <label key={item.id} className={item.checked ? 'active' : ''} onClick={() => changeFilterParams('cuisines', item.id)}>
                    <span>{item.name}</span>
                  </label>
                ))} */}
                <div className='categories'>
                  {filterParams.cuisines_categories?.map((item, index) => (
                    <label
                      key={item.id}
                      className={haseCheckedItem(item.id) || item.name === currentCate ? 'active' : ''}
                      onClick={() => setCurrentCate(item.name)}
                    >
                      <span>{item.name}</span>
                    </label>
                  ))}
                </div>
                <div className='filter-date-items'>
                  {filterParams.cuisines
                    .filter(_ => cuisinesList.includes(_.id))
                    .map((item, index) => (
                      <label key={item.id} className={item.checked ? 'active' : ''} onClick={() => changeFilterParams('cuisines', item.id)}>
                        <span>{item.name}</span>
                        {item.checked && <i className='icon icon-check-normal-red' />}
                      </label>
                    ))}
                </div>
              </div>
            </React.Fragment>
          ) : null}
          {curFilterKey === 'filters' ? (
            <React.Fragment>
              {filterParams.tags?.length > 0 && isRestaurant && (
                <React.Fragment>
                  <div className='filter-title'>{t('Browse.tags')}</div>
                  <div className='filter-items'>
                    {filterParams.tags?.map((item, index) => (
                      <label key={item.id} className={item.checked ? 'active' : ''} onClick={() => changeFilterParams('tags', index)}>
                        <img src={item.icon_url} alt='' />
                        <span>{item.name}</span>
                      </label>
                    ))}
                  </div>
                </React.Fragment>
              )}
              {filterParams.price_range?.length > 0 && (
                <React.Fragment>
                  <div className='filter-title'>{t('Browse.price_range')}</div>
                  <div className='filter-items'>
                    {filterParams.price_range?.map((item, index) => (
                      <label
                        key={item.id}
                        className={item.checked ? 'active' : ''}
                        onClick={() => changeFilterParams('price_range', index, 'radio')}
                      >
                        <span>{item.name}</span>
                      </label>
                    ))}
                  </div>
                </React.Fragment>
              )}
              {filterParams.distance?.length > 0 && (
                <React.Fragment>
                  <div className='filter-title'>{t('Browse.distance')}</div>
                  <div className='filter-items'>
                    {filterParams.distance?.map((item, index) => (
                      <label
                        key={item.id}
                        className={item.checked ? 'active' : ''}
                        onClick={() => changeFilterParams('distance', index, 'radio')}
                      >
                        <span>&lt; {item.name} m</span>
                      </label>
                    ))}
                  </div>
                </React.Fragment>
              )}
              {filterParams.extras?.length > 0 && isRestaurant && (
                <React.Fragment>
                  <div className='filter-title'>{t('Browse.others')}</div>
                  <div className='filter-items'>
                    {filterParams.extras?.map((item, index) => (
                      <label key={item.id} className={item.checked ? 'active' : ''} onClick={() => changeFilterParams('extras', index)}>
                        <span>{item.name}</span>
                      </label>
                    ))}
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : null}
          {curFilterKey === 'sort' ? (
            <React.Fragment>
              <div className='filter-date-items'>
                {filterParams?.sort.map((item, index) => (
                  <label
                    key={item.name}
                    className={item.checked ? 'active' : ''}
                    onClick={() => changeFilterParams('sort', index, 'radio')}
                  >
                    <span>{item.name}</span>
                    {item.checked && <i className='icon icon-check-normal-red' />}
                  </label>
                ))}
              </div>
            </React.Fragment>
          ) : null}
        </section>
        {curFilterKey !== 'sort' && (
          <footer className='active' onClick={() => applyFilter()}>
            <Button type='primary'>{isShowBack ? t('Browse.back') : t('Browse.apply')}</Button>
          </footer>
        )}
      </Modal>
    </div>
  )
}

export default CollectionFilter
